<!-- 测试文件 路径为openMap -->
<template>
  <div class="map-container">
    <!-- <div id="map"></div>
    <div class="popup" ref="popup"></div> -->
  </div>
</template>

<script>
// import 'ol/ol.css';
// import Map from 'ol/Map';
// import View from 'ol/View';
// import Feature from 'ol/Feature';
// import Point from 'ol/geom/Point';
// import { Tile as TileLayer, Vector as VectorLayer } from 'ol/layer';
// import { OSM, Vector as VectorSource, XYZ } from 'ol/source';
// import Overlay from 'ol/Overlay';
// import { Circle as sCircle, Fill, Stroke, Style } from 'ol/style';

export default {
  // name: 'MapComponent',
  // data() {
  //   return {
  //     map: null,
  //     markers: [],
  //     popup: null,
  //     position: [120.36173, 36.082949],
  //     zoom: 13,
  //   };
  // },
  // mounted() {
  //   this.initMap();
  //   this.getData();
  // },
  // methods: {
  //   // 初始化地图
  //   initMap() {
  //     // 创建离线瓦片图层
  //     const offlineLayer = new TileLayer({
  //       source: new XYZ({
  //         url: 'http://192.168.0.88/amap' + '/{z}/{x}/{y}.png', // 设置本地离线瓦片所在路径
  //       }),
  //     });

  //     // 创建标点符号图层
  //     const vectorLayer = new VectorLayer({
  //       source: new VectorSource({
  //         features: [],
  //       }),
  //       style: new Style({
  //         image: new sCircle({
  //           radius: 12,
  //           stroke: new Stroke({
  //             // 边界样式
  //             color: 'rgba(64, 169, 255,.5)', // 边界颜色
  //             width: 15, // 边界宽度
  //           }),
  //           fill: new Fill({
  //             color: '#40a9ff',
  //           }),
  //         }),
  //       }),
  //     });

  //     // 创建地图
  //     this.map = new Map({
  //       target: 'map',
  //       layers: [
  //         offlineLayer,
  //         vectorLayer,
  //         // 设置其他版本地图 可以代替瓦片
  //         // new TileLayer({
  //         //   source: new OSM(),
  //         // }),
  //       ],
  //       view: new View({
  //         center: this.position, // 地图中心点
  //         zoom: this.zoom, // 缩放
  //         projection: 'EPSG:4326', // 坐标系
  //       }),
  //     });

  //     // 创建弹出框
  //     this.popup = new Overlay({
  //       element: this.$refs.popup,
  //       autoPan: true,
  //       autoPanAnimation: {
  //         duration: 250,
  //       },
  //     });
  //     this.map.addOverlay(this.popup);

  //     // 监听鼠标移动事件
  //     this.map.on('pointermove', this.onMouseMove);

  //     // 监听鼠标单击事件
  //     // this.map.on('singleclick', this.onMapClick);
  //   },

  //   // 获取数据
  //   async getData() {
  //     this.$get('things/frontPage/innet').then((response) => {
  //       console.log(response);
  //       this.markers = response.data;
  //       setTimeout(() => {
  //         this.addMarkers();
  //       }, 500);
  //     });
  //   },

  //   // 添加标记
  //   addMarkers() {
  //     const features = [];
  //     for (const marker of this.markers) {
  //       const feature = new Feature({
  //         geometry: new Point([marker.lon, marker.lat]),
  //         name: marker.name,
  //         description: marker.description,
  //       });
  //       features.push(feature);
  //     }
  //     const vectorLayer = this.map.getLayers().getArray()[1];
  //     const source = vectorLayer.getSource();
  //     source.addFeatures(features);
  //   },

  //   // 鼠标移动事件处理函数
  //   onMouseMove(event) {
  //     console.log(event);
  //     const pixel = this.map.getEventPixel(event.originalEvent);
  //     const feature = this.map.forEachFeatureAtPixel(pixel, (feature) => feature);
  //     if (feature) {
  //       const coordinates = feature.getGeometry().getCoordinates();
  //       const name = feature.get('name');
  //       const description = feature.get('description');
  //       this.popup.getElement().innerHTML = `<h4>${name}</h4><p>${description}</p>`;
  //       this.popup.setPosition(coordinates);
  //       this.popup.getElement().style.display = 'block';
  //     } else {
  //       this.popup.getElement().style.display = 'none';
  //     }
  //   },

  //   // 地图单击事件处理函数
  //   onMapClick(event) {
  //     // const pixel = this.map.getEventPixel(event.originalEvent);
  //     // const feature = this.map.forEachFeatureAtPixel(pixel, (feature) => feature);
  //     // if (feature) {
  //     //   const coordinates = feature.getGeometry().getCoordinates();
  //     //   console.log(coordinates);
  //     // }
  //   },
  // },
};
</script>
<style scoped>
.map-container {
  height: 100%;
}

#map {
  height: 100%;
}

.popup {
  position: absolute;
  background-color: white;
  padding: 5px;
  border-radius: 5px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2), 0 2px 10px rgba(0, 0, 0, 0.1);
}
</style>
